import React from 'react';
import clsx from 'clsx';

import Select from '@components/_shared/select';
import { BaseComponentProps } from '@utils/types/baseComponents';
import { MarketType } from '@utils/types/city';
import { NeighborhoodType } from '@utils/types/neighborhoods';
import { FilterParamsType } from '@utils/types/searchListingsContext';

import styles from './styles.module.scss';

type Props = {
  markets: MarketType[];
  neighborhoods: NeighborhoodType[];
  filters: FilterParamsType;
  changeMarket: (market: string) => void;
  changeNeighborhoods: (neighborhoods: string[]) => void;
} & BaseComponentProps;

export function LocationSelectors(props: Props) {
  const {
    containerStyle,
    markets,
    neighborhoods,
    filters,
    changeMarket,
    changeNeighborhoods,
  } = props;

  const marketOptions = markets.map((c) => ({ label: c.name, value: c.slug }));
  const neighborhoodOptions = neighborhoods
    .filter(
      (n) => n.market.slug.current === filters.market && !!n.slug?.current
    )
    .map((c) => ({ label: c.name, value: c.slug.current }));

  return (
    <>
      <Select
        value={filters.market}
        options={marketOptions}
        onSelect={(val) => changeMarket(val as string)}
        placeholder={filters.market === null ? 'Map Area' : 'Select a Market'}
        containerStyle={clsx([styles.marketSelector, containerStyle])}
        customEmptyValue={{ label: 'All Markets', value: '' }}
        withRoundCorners
      />

      {!!filters.market && neighborhoodOptions.length > 0 && (
        <Select
          value={filters.neighborhoods}
          isDisabled={!filters.market}
          options={neighborhoodOptions}
          onSelect={(val) => changeNeighborhoods(val as string[])}
          placeholder="All Neighborhoods"
          containerStyle={clsx([styles.neighborhoodSelector, containerStyle])}
          customEmptyValue={{ label: 'All Neighborhoods', value: '' }}
          multiple
          withRoundCorners
        />
      )}
    </>
  );
}
